import React from "react";

import { Grid, Group, Section, Select } from "@samskip/frontend-components";
import {
  Control,
  Controller,
  FieldErrors,
  UseFormGetValues,
  UseFormTrigger,
} from "react-hook-form";
import { useTranslation } from "react-i18next";
import { nameof } from "ts-simple-nameof";

import { getErrorMessage } from "@assets/utilities/translateUtilities";
import { DomesticPriceAddress } from "features/domestic/schemas";

import { CalculatePriceTranslation } from "../../constants";
import { CalculatorForm } from "../../formValues";

interface RouteSectionProps {
  control: Control<CalculatorForm>;
  errors: FieldErrors<CalculatorForm>;
  locations: DomesticPriceAddress[];
  isCalculating: boolean;
  isLoadingLocations: boolean;
  getValues: UseFormGetValues<CalculatorForm>;
  trigger: UseFormTrigger<CalculatorForm>;
}

const RouteSection = ({
  control,
  errors,
  locations,
  isCalculating,
  isLoadingLocations,
  getValues,
  trigger,
}: RouteSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section title={t(CalculatePriceTranslation.ROUTE_SECTION)}>
      <Grid mdCol={4}>
        <Group
          errorMessage={getErrorMessage("Departure", errors)}
          title={t(CalculatePriceTranslation.DEPARTURE)}
        >
          <Controller
            control={control}
            name={nameof<CalculatorForm>((i) => i.Departure)}
            render={({ field }) => (
              <Select
                fullWidth
                getOptionValue={(option) => option.value}
                hasError={errors.Departure != null}
                id="departure"
                isDisabled={isCalculating}
                isLoading={isLoadingLocations}
                onChange={(option) => {
                  field.onChange(option ?? null);
                  if (getValues("Arrival") != null)
                    trigger(["Departure", "Arrival"]);
                }}
                options={locations}
                placeholder={t(CalculatePriceTranslation.PLACEHOLDER_TOWN_CITY)}
                value={field.value ?? null}
              />
            )}
          />
        </Group>

        <Group
          errorMessage={getErrorMessage("Arrival", errors)}
          title={t(CalculatePriceTranslation.ARRIVAL)}
        >
          <Controller
            control={control}
            name={nameof<CalculatorForm>((i) => i.Arrival)}
            render={({ field }) => (
              <Select
                fullWidth
                getOptionValue={(option) => option.value}
                hasError={errors.Arrival != null}
                id="arrival"
                isDisabled={isCalculating}
                isLoading={isLoadingLocations}
                onChange={(option) => {
                  field.onChange(option ?? null);
                  if (getValues("Departure") != null)
                    trigger(["Departure", "Arrival"]);
                }}
                options={locations}
                placeholder={t(CalculatePriceTranslation.PLACEHOLDER_TOWN_CITY)}
                value={field.value ?? null}
              />
            )}
          />
        </Group>
      </Grid>
    </Section>
  );
};

export default RouteSection;
